export default "__VITE_ASSET__BY53TxkN__"